import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useHashScroll = () => {
  const location = useLocation();

  useEffect(() => {
    const { hash } = location;
    if (hash) {
      const id = hash.replace("#", "");

      // Use a small timeout to ensure the DOM is fully rendered before scrolling
      const timer = setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          // Get the element's position
          const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          // Account for the navbar height (80px based on the main padding-top in Navbar.css)
          const offsetPosition = elementPosition - 80;

          // Smooth scroll to the element
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      }, 100); // Small delay to ensure render completion

      return () => clearTimeout(timer);
    }
  }, [location]); // Re-run the effect if the location changes
};

export default useHashScroll;
